import { createSearchParams, useNavigate } from 'react-router';

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Button } from '@mui/material';

import { useActionMenu } from 'pages/compra/pedido-realizado/contexts';

export function PedidoRealizadoGradeBtn() {
    const { row, disabledActions } = useActionMenu();
    const navigate = useNavigate();

    const onClickGrade = (): void => {
        const { loja, tipoGrade } = row;
        const { dsNomeFantasia, cdLoja, idLoja } = loja;

        const path = {
            pathname: '/logistica/grade/form',
            search: createSearchParams({
                idLoja: JSON.stringify({ idLoja, cdLoja, dsNomeFantasia }),
                ...(tipoGrade && { idTipoGrade: JSON.stringify(tipoGrade) }),
            }).toString(),
        };

        navigate(path);
    };

    return (
        <Button color="inherit" disabled={disabledActions} onClick={onClickGrade} startIcon={<CalendarMonthIcon />}>
            Atribuir Grade
        </Button>
    );
}
